import React from 'react';
import { doesAddonExist } from '../../functions';
import { AddonCategoryType, ENUM_ADDON_SELECTION } from 'models/addon-category.model';
import { AddonType } from 'models/addon.model';
import { AddonMealType } from '../../types';
import DetailsCard from 'components/base/cards/details-card';

const MultiSelectionAddon = ({
  filteredAddOn,
  handleSelectAddon,
  addonSelection
}: {
  filteredAddOn: AddonCategoryType[];
  handleSelectAddon: (addon: AddonType, item: AddonCategoryType) => void;
  addonSelection: AddonMealType;
}) => {
  addonSelection;
  return (
    <div>
      {filteredAddOn[0]?.meal_category_selection_type.name === 'MULTI_SELECTION' && (
        <div className='space-y-6'>
          {filteredAddOn[0].summary && (
            <p className='pb-4 font-medium'>* {filteredAddOn[0].summary}</p>
          )}
          <div className='grid md:grid-cols-2 lg:grid-cols-3 justify-between gap-4 gap-y-6'>
            {filteredAddOn[0]?.addons.map((addon, i) => (
              <DetailsCard
                key={i}
                title={`${addon?.meal_data?.name ?? addon?.name} `}
                cardType={ENUM_ADDON_SELECTION.MULTI_SELECTION}
                price={addon.meal_data.amount}
                checked={doesAddonExist(addon.meal_data.id, addonSelection)}
                onChange={() => handleSelectAddon(addon, filteredAddOn[0])}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelectionAddon;
